module.exports = __webpack_public_path__ + "img/218067308976029_image.jpg";